<div class="h-100 w-100 d-flex flex-column flex-grow-1">
    <div class="position-absolute w-100 d-flex zx-z-index-1" [class.justify-content-end]="isRTL">
        <button type="button" mat-icon-button aria-label="Close dialog" (click)="closeTransferFilesToUserDialog()"
            class="close-icon d-flex align-items-center justify-content-center zx-z-index-2" [class.text-white]="isDarkMode">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="d-flex flex-grow-1 flex-column align-items-center px-3 pt-4 pb-3 px-md-4 pt-md-5 gap-3 w-100 position-relative">
        <h4 class="text-center fw-bold m-0 pt-3 pt-lg-0" [class.zx-ltr]="!isRTL" [class.text-white]="isDarkMode">
            {{ 'su-management.transfer-files-to-user' | translate }}
        </h4>

        <!-- Files list - scrollable area -->
        <div *ngIf="files && files.length > 0" class="d-flex flex-grow-1 w-100 position-relative">
            <div class="position-absolute h-100 d-flex flex-column align-items-center flex-grow-1 w-100 gap-2 overflow-auto p-1 p-lg-2 zx-bg-gray-v-light-opacity rounded-2"
                [class.zx-border-gray-25-pr]="isDarkMode">
                <div
                    *ngFor="let file of files; index as i"
                    class="d-flex w-100 row p-2 zx-border-gray-v-v-light zx-bg-light shadow-85 rounded-2 gap-2 gap-md-0"
                    [class.zx-bg-dark-no-border]="isDarkMode" [class.align-items-end]="!isRTL">
                    <!-- name - multi page -->
                    <span *ngIf="file.images.length > 1" class="zx-text-small zx-text-pink col-12 w-100 p-0 pb-lg-2 px-lg-2"
                        [class.text-start]="!isRTL" [class.fw-bold]="!isDarkMode" [class.zx-text-white]="isDarkMode"
                        [class.zx-ltr]="!isRTL">
                        <span class="d-sm-none">
                            <span>{{ getDisplayFileNameAfterSplit(file) | slice : 0 : 17 }}</span>
                            <span *ngIf="getDisplayFileNameAfterSplit(file).length > 17">...</span>
                            <span class="zx-100-opacity">--</span>
                            <span class="fw-normal zx-text-tiny text-green">
                                <span>(</span>
                                <span>{{ file.images.length }}</span>
                                <span class="zx-text-tiny-tiny">{{ "printing-table.pages-short" | translate }}</span>
                                <span>)</span>
                            </span>
                        </span>
                        <span class="d-none d-sm-flex">
                            <span>{{ getDisplayFileNameAfterSplit(file) | slice : 0 : 40 }}</span>
                            <span *ngIf="getDisplayFileNameAfterSplit(file).length > 40">...</span>
                            <span class="zx-100-opacity">--</span>
                            <span class="fw-normal text-green">
                                <span>(</span>
                                <span>{{ file.images.length }}</span>
                                <span class="zx-text-tiny">{{ "printing-table.pages-short" | translate }}</span>
                                <span>)</span>
                            </span>
                        </span>
                    </span>
                    <!-- Single file name -->
                    <span *ngIf="file.images.length === 1" class="zx-text-small col-12 w-100 p-0 pb-lg-2 px-lg-2"
                        [class.text-start]="!isRTL" [class.fw-bold]="!isDarkMode" [class.zx-text-white]="isDarkMode"
                        [class.zx-ltr]="!isRTL">
                        <span class="d-sm-none">
                            <span>{{ getDisplayFileNameAfterSplit(file) | slice : 0 : 17 }}</span>
                            <span *ngIf="getDisplayFileNameAfterSplit(file).length > 17">...</span>
                        </span>
                        <span class="d-none d-sm-flex">
                            <span>{{ getDisplayFileNameAfterSplit(file) | slice : 0 : 40 }}</span>
                            <span *ngIf="getDisplayFileNameAfterSplit(file).length > 40">...</span>
                        </span>
                    </span>
                    <!-- Images -->
                    <article *ngFor="let image of file.images; index as j"
                        class="d-flex align-items-center gap-2 gap-lg-3 p-0"
                        [class.zx-border-gray-top-25-pr]="file.images.length > 1"
                        [class.zx-border-gray-left-25-pr-md]="j % 2 === 0 && file.images.length > 1"
                        [class.flex-row-reverse]="!isRTL" [class.col-12]="file.images.length === 1"
                        [class.py-1]="file.images.length > 1" [class.py-lg-2]="file.images.length > 1"
                        [class.ps-md-2]="file.images.length > 1 && j % 2 === 0"
                        [class.pe-md-2]="file.images.length > 1 && j % 2 !== 0"
                        [class.col-md-6]="file.images.length > 1">
                        <!-- image -->
                        <article
                            class="zx-order-summery-image-con d-flex flex-column justify-content-between align-items-center position-relative p-1 p-lg-2 rounded-1 bg-white zx-border-gray-v-v-light shadow-85-light">
                            <!-- thumbnail -->
                            <div class="d-flex zx-medium-plus-icon-size rounded-1">
                                <img *ngIf="!imageErrors[i]?.[j]" (error)="onImageError(i, j)"
                                    class="w-100 h-100 object-fit-contain"
                                    [src]="getImageSrc(file, j)"
                                    [alt]="getDisplayFileNameAfterSplit(file)" />
                                <!-- error finding image src? -->
                                <div *ngIf="imageErrors[i]?.[j]" class="d-flex flex-column align-items-center">
                                    <img class="zx-small-plus-icon-size" src="assets/images/negative-icon.svg" />
                                    <b class="zx-text-tiny-tiny text-red text-center zx-lh-tiny-tiny"
                                        [class.zx-text-white]="isDarkMode">
                                        {{ "my-orders.no-img-src" | translate }}
                                    </b>
                                </div>
                            </div>
                            
                            <!-- Print settings bubbles - Express -->
                            <div *ngIf="printingService === 'express' && file.printSettings?.paperType" 
                                class="d-flex flex-column gap-1 gap-lg-2 w-100 mt-2">
                                <!-- paper & bw -->
                                <div class="d-flex gap-1 gap-lg-2 align-items-center" [class.flex-row-reverse]="!isRTL">
                                    <!-- paper -->
                                    <div *ngIf="file.paperSerialName" class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray text-center"
                                        [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                                        <b class="zx-text-tiny zx-text-sm-small" [class.text-white]="isDarkMode">
                                            {{ 'paper-type.name-short.' + file.paperSerialName | translate }}
                                        </b>
                                    </div>
                                    <!-- bw -->
                                    <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray text-center"
                                        [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                                        <span class="zx-text-tiny zx-text-sm-small" [class.text-white]="isDarkMode">
                                            <span *ngIf="!file.printSettings.bw">
                                                {{ "printing-table.color-color" | translate }}
                                            </span>
                                            <span *ngIf="file.printSettings.bw">
                                                {{ "printing-table.color-bandw" | translate }}
                                            </span>
                                        </span>
                                    </div>
                                </div>
                                <!-- doubleSided & fit -->
                                <div class="d-flex gap-1 gap-lg-2 align-items-center" [class.flex-row-reverse]="!isRTL">
                                    <!-- doubleSided -->
                                    <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray text-center"
                                        [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                                        <span class="zx-text-tiny zx-text-sm-small" [class.text-white]="isDarkMode">
                                            <span *ngIf="!file.printSettings.doubleSided">
                                                {{ "printing-table.sides-one" | translate }}
                                            </span>
                                            <span *ngIf="file.printSettings.doubleSided">
                                                {{ "printing-table.sides-two" | translate }}
                                            </span>
                                        </span>
                                    </div>
                                    <!-- fit -->
                                    <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray text-center"
                                        [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                                        <span class="zx-text-tiny zx-text-sm-small" [class.text-white]="isDarkMode">
                                            <span *ngIf="!file.printSettings.fit && !file.printSettings.cropRatio">
                                                {{ "order-summary-resize-original" | translate }}
                                            </span>
                                            <span *ngIf="file.printSettings.fit && !file.printSettings.cropRatio">
                                                {{ "order-summary-resize-maximal" | translate }}
                                            </span>
                                            <span *ngIf="file.printSettings.cropRatio">
                                                {{ "order-summary-resize-crop" | translate }}
                                            </span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            
                            <!-- Print settings bubbles - Plotter -->
                            <div *ngIf="printingService === 'plotter' && image.printSettings?.paperType" 
                                class="d-flex flex-column gap-1 gap-lg-2 w-100 mt-2">
                                <!-- paper & bw & resize -->
                                <div class="d-flex gap-1 gap-lg-2 align-items-center" [class.flex-row-reverse]="!isRTL">
                                    <!-- paper -->
                                    <div *ngIf="image.paperSerialName" class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray text-center"
                                        [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                                        <b class="zx-text-tiny" [class.text-white]="isDarkMode">
                                            {{ 'paper-type.name-short.' + image.paperSerialName | translate }}
                                        </b>
                                    </div>
                                    <!-- bw -->
                                    <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray text-center"
                                        [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                                        <span class="zx-text-tiny" [class.text-white]="isDarkMode">
                                            <span *ngIf="!image.printSettings.bw">
                                                {{ "printing-table.color-color" | translate }}
                                            </span>
                                            <span *ngIf="image.printSettings.bw">
                                                {{ "printing-table.color-bandw" | translate }}
                                            </span>
                                        </span>
                                    </div>
                                    <!-- resize -->
                                    <div *ngIf="file.images.length === 1 && image.resizeFactor"
                                        class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray text-center"
                                        [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                                        <span class="zx-text-tiny" [class.text-white]="isDarkMode"
                                            [class.zx-ltr]="!isRTL">
                                            <span *ngIf="image.resizeFactor > 100">
                                                {{ "order-summary-resize-bigger" | translate }}
                                            </span>
                                            <span *ngIf="image.resizeFactor < 100">
                                                {{ "order-summary-resize-smaller" | translate }}
                                            </span>
                                            <span *ngIf="image.resizeFactor === 100">
                                                {{ "order-summary-resize-original" | translate }}
                                            </span>
                                            <span *ngIf="image.resizeFactor !== 100" [class.zx-ltr]="!isRTL">
                                                <span *ngIf="isRTL">%</span>
                                                <span>{{ image.resizeFactor }}</span>
                                                <span *ngIf="!isRTL">%</span>
                                            </span>
                                        </span>
                                    </div>
                                </div>
                                <!-- center & borders -->
                                <div class="d-flex gap-1 gap-lg-2 align-items-center" [class.flex-row-reverse]="!isRTL">
                                    <!-- center -->
                                    <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray text-center"
                                        [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                                        <span class="zx-text-tiny" [class.text-white]="isDarkMode">
                                            <span *ngIf="!image.printSettings.centered">
                                                {{ "order-summary-not-centered" | translate }}
                                            </span>
                                            <span *ngIf="image.printSettings.centered">
                                                {{ "order-summary-is-centered" | translate }}
                                            </span>
                                        </span>
                                    </div>
                                    <!-- borders -->
                                    <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray text-center"
                                        [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                                        <span class="zx-text-tiny" [class.text-white]="isDarkMode">
                                            <span *ngIf="!image.printSettings.cmFromTop">
                                                {{ "order-summary-not-borders" | translate }}
                                            </span>
                                            <span *ngIf="image.printSettings.cmFromTop">
                                                {{ "order-summary-is-borders" | translate }}
                                            </span>
                                        </span>
                                    </div>
                                </div>
                                <!-- resize for multi-page -->
                                <div *ngIf="file.images.length > 1 && image.resizeFactor" 
                                    class="d-flex gap-1 gap-lg-2 align-items-center" [class.flex-row-reverse]="!isRTL">
                                    <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray text-center"
                                        [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                                        <span class="zx-text-tiny" [class.text-white]="isDarkMode"
                                            [class.zx-ltr]="!isRTL">
                                            <span *ngIf="image.resizeFactor > 100">
                                                {{ "order-summary-resize-bigger" | translate }}
                                            </span>
                                            <span *ngIf="image.resizeFactor < 100">
                                                {{ "order-summary-resize-smaller" | translate }}
                                            </span>
                                            <span *ngIf="image.resizeFactor === 100">
                                                {{ "order-summary-resize-original" | translate }}
                                            </span>
                                            <span *ngIf="image.resizeFactor !== 100">
                                                <span *ngIf="isRTL">%</span>
                                                <span>{{ image.resizeFactor }}</span>
                                                <span *ngIf="!isRTL">%</span>
                                            </span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </article>
                    </article>
                </div>
            </div>
        </div>
    </div>

    <!-- Email field and button - fixed at bottom -->
    <div class="w-100 px-3 pb-3 d-flex flex-column gap-3">
        <mat-form-field class="w-100" [ngClass]="isRTL ? 'zx-rtl' : 'zx-ltr'">
            <input matInput name="email" [(ngModel)]="userEmail" type="email" [ngClass]="isRTL ? 'zx-rtl' : 'zx-ltr'"
                [placeholder]="'log-in-dialog-withmail-email' | translate" #emailInput="ngModel">
            <mat-error *ngIf="emailInput.invalid" [ngClass]="isRTL ? 'text-end zx-rtl' : 'text-start zx-ltr'">
                {{ "log-in-dialog-mailexist-mail-not-valid" | translate }}
            </mat-error>
        </mat-form-field>
        <button mat-raised-button color="primary" (click)="onTransferFiles()" 
            [disabled]="!userEmail || userEmail.length < 3 || isLoading"
            class="text-white rounded-pill w-100">
            <span *ngIf="!isLoading">{{ 'su-management.transfer-files-to-user' | translate }}</span>
            <span *ngIf="isLoading">{{ 'su-management.transfer-files-to-user.loading' | translate }}</span>
        </button>
    </div>
</div>

